const convertUnicodeToEmoji = (value: string): string => String.fromCodePoint(parseInt(value,16));
export default convertUnicodeToEmoji;
